import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './styles.css';
import ModalDesbloquearCartao from '../../Painel/ModalDesbloquearCartao/ModalDesbloquearCartao';
import moment from 'moment-timezone';
import ModalBloquearCartao from '../../Painel/ModalBloquearCartao/ModalBloquearCartao';
import { Link } from 'react-router-dom';

export default function Cartao() {
  const cartao = useSelector((state) => {
    return state.parceiro.cartao;
  });

  const [mostrarModalDesbloquearCartao, setMostrarModalDesbloquearCartao] =
    useState(false);
  const [mostrarModalBloquearCartao, setMostrarModalBloquearCartao] =
    useState(false);

  const fecharModalDesbloquearCartao = () => {
    setMostrarModalDesbloquearCartao(false);
  };

  const fecharModalBloquearCartao = () => {
    setMostrarModalBloquearCartao(false);
  };

  return (
    <Container className="mt-5 mb-5">
      <div>
        <h5>CARTÃO</h5>
        <hr className="hr-loja mt-0" />
      </div>
      <Row>
        <Col>
          <Link to="/loja/credito">
            <img
              className="w-100"
              src="/imagens/banner_cartao.jpg"
              alt="Logo cartão"
            ></img>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3 mb-3">
        <Col xs={12} lg={4} className="mt-3 mb-3">
          {cartao && cartao.numero && (
            <div className="card-cartao">
              <span className="card-cartao-titulo">
                <i className="fas fa-credit-card mr-2" />
                Saldo
              </span>
              <span className="card-cartao-subtitulo">
                {parseFloat(cartao.saldo).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
              <div className="card-cartao-footer">
                <span className="small">
                  Atualizado em{' '}
                  {moment(cartao.atualizadoEm).format('DD/MM/YYYY HH:MM:SS')}
                </span>
              </div>
            </div>
          )}
          {!cartao && (
            <div className="card-sem-cartao">
              <span>
                Você ainda não possui seu Cartão MASTERCARD® Clube Pro Pintor
              </span>
              <div className="card-sem-cartao-footer"></div>
            </div>
          )}
        </Col>
        <Col xs={12} lg={4} className="mt-3 mb-3">
          <img className="w-100" src="/imagens/credito.png" alt="Crédito"></img>
        </Col>
        <Col xs={12} lg={4} className="mt-3 mb-3">
          <a href="https://surpreenda.naotempreco.com.br/rewards/vouchers/surpreenda">
            <img
              className="w-100"
              src="/imagens/mastercard.png"
              alt="Mastercard"
            ></img>
          </a>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6} lg={3} className="d-flex flex-column mt-3">
          {cartao &&
          cartao.numero &&
          cartao.bloqueado &&
          !cartao.emDesbloqueio ? (
            <>
              <button
                className="btn-limpo"
                onClick={(e) => setMostrarModalDesbloquearCartao(true)}
              >
                <div className="cartao-info-verde">
                  <i className="fa fa-unlock" />
                  <span>DESBLOQUEAR CARTÃO</span>
                </div>
              </button>
              <span className="mt-2 mt-1 font-weight-bold">
                SEU CARTÃO ESTÁ BLOQUEADO
              </span>
              <span className="text-justify mb-2">
                Ligue para <a href="tel:15997929110"> (11) 99792-9110 </a> de
                segunda a sexta das 9h às 18h ou clique acima e solicite seu
                desbloqueio.
              </span>
            </>
          ) : null}
          {cartao &&
          cartao.numero &&
          cartao.bloqueado &&
          cartao.emDesbloqueio ? (
            <>
              <button className="btn-limpo">
                <div className="cartao-info-verde">
                  <i className="fa fa-unlock" />
                  <span>DESBLOQUEAR CARTÃO</span>
                </div>
              </button>
              <span className="mt-2 mt-1 font-weight-bold">
                SOLICITAÇÃO EM ANDAMENTO
              </span>
              <span className="text-justify mb-2">
                Ligue para <a href="tel:15997929110"> (11) 99792-9110 </a> de
                segunda a sexta das 9h às 18h ou clique acima e solicite seu
                desbloqueio.
              </span>
            </>
          ) : null}
          {!cartao && (
            <>
              <div className="cartao-info-verde">
                <i className="fa fa-unlock" />
                <span>DESBLOQUEAR CARTÃO</span>
              </div>
              <span className="mt-2 mt-1 font-weight-bold">
                VOCÊ NÃO POSSUI UM CARTÃO
              </span>
              <span className="text-justify mb-2">
                Ligue para <a href="tel:15997929110"> (11) 99792-9110 </a> de
                segunda a sexta das 9h às 18h para mais dúvidas.
              </span>
            </>
          )}
          {cartao && cartao.numero && !cartao.bloqueado && (
            <>
              <div className="cartao-info-verde">
                <i className="fa fa-unlock" />
                <span>DESBLOQUEAR CARTÃO</span>
              </div>
              <span className="mt-2 mt-1 font-weight-bold">
                CARTÃO DESBLOQUEADO
              </span>
              <span className="text-justify mb-2">
                Ligue para <a href="tel:15997929110"> (11) 99792-9110 </a> de
                segunda a sexta das 9h às 18h para mais dúvidas.
              </span>
            </>
          )}
        </Col>
        <Col xs={12} md={6} lg={3} className="d-flex flex-column mt-3">
          {!cartao || (cartao && cartao.numero && cartao.bloqueado) ? (
            <>
              <div className="cartao-info-vermelho">
                <i className="fa fa-lock" />
                <span>BLOQUEAR CARTÃO</span>
              </div>
              <span className="mt-2 mt-1 font-weight-bold">PERDA OU ROUBO</span>
              <span className="text-justify mb-2">
                Você ainda não possui um Cartão MASTERCARD® Clube Pro Pintor
                para bloquear.
              </span>
            </>
          ) : null}
          {cartao && cartao.numero && cartao.bloqueado === 0 ? (
            <>
              <button
                className="btn-limpo"
                onClick={(e) => setMostrarModalBloquearCartao(true)}
              >
                <div className="cartao-info-vermelho">
                  <i className="fa fa-unlock" />
                  <span>BLOQUEAR CARTÃO</span>
                </div>
              </button>
              <span className="mt-2 mt-1 font-weight-bold">PERDA OU ROUBO</span>
              <span className="text-justify mb-2">
                Faça o bloqueio do seu cartão para inutilizar o uso do mesmo.
              </span>
            </>
          ) : null}
        </Col>
        <Col xs={12} md={6} lg={3} className="d-flex flex-column mt-3">
          <div className="cartao-info-preto">
            <i className="fa fa-phone" />
            <span>LIGAR PARA CENTRAL</span>
          </div>
          <span className="mt-2 mt-1 font-weight-bold">ATENDIMENTO</span>
          <span className="text-justify mb-2">
            Em caso de dúvidas, entre em contato pelo telefone
            <a href="tel:15997929110"> (11) 99792-9110 </a>
            de segunda a sexta das 9h às 18h.
          </span>
        </Col>
        <Col xs={12} md={6} lg={3} className="d-flex flex-column mt-3">
          <Link to="/loja/credito" style={{ textDecoration: 'none' }}>
            <div className="cartao-info-marrom">
              <i className="fa fa-credit-card" />
              <span>RECARREGUE SEU CARTÃO</span>
            </div>
          </Link>

          <span className="mt-2 mt-1 font-weight-bold">RECARREGUE</span>
          <span className="text-justify mb-2">
            Já tem o Cartão MASTERCARD® Clube Pro Pintor? Clique acima e RESGATE
            mais créditos para seu cartão.
          </span>
        </Col>
      </Row>
      <ModalDesbloquearCartao
        show={mostrarModalDesbloquearCartao}
        onHide={fecharModalDesbloquearCartao}
      />
      <ModalBloquearCartao
        show={mostrarModalBloquearCartao}
        onHide={fecharModalBloquearCartao}
      />
    </Container>
  );
}
